"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = exports.getPhysicsPosition = exports.applyPhysicsItem = exports.drawPhysicsItem = void 0;
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var clickEater_sidecar_1 = require("@uiParts/clickEater-sidecar");
// import { voyageCamera } from '@voyage/camera/voyageCamera-sidecar'
// import { crokinolePucks } from '../entities/crokinolePucks-sidecar'
// import { InputState } from '../input/crokinoleGamepad'
// import { crokinoleGamepad } from '../input/crokinoleGamepad-sidecar'
// import { IRapierUserData } from '../physics/physics_rapier_loader'
// import { physics_rapier_loader } from '../physics/physics_rapier_loader-sidecar'
// import { vectorUtils } from '../physics/vectorUtils-sidecar'
// import { crokinoleCamera } from './crokinoleCamera-sidecar'
// import { crokinoleDefs } from './crokinoleDefs-sidecar'
// import {
//   CrokinoleControlScheme,
//   CrokinoleGameStates,
//   advanceState,
// } from './crokinoleGameState'
// import { crokinoleGameState } from './crokinoleGameState-sidecar'
// import { crokinoleRenderer } from './crokinoleRenderer-sidecar'
var minigolfCamera_sidecar_1 = require("../camera/minigolfCamera-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var minigolfCreatures_sidecar_1 = require("../entities/minigolfCreatures-sidecar");
var minigolfGamepad_1 = require("../input/minigolfGamepad");
var minigolfGamepad_sidecar_1 = require("../input/minigolfGamepad-sidecar");
var minigolf_input_sidecar_1 = require("../multi/minigolf_input-sidecar");
var minigolfPhysics_rapier_loader_sidecar_1 = require("../physics/minigolfPhysics_rapier_loader-sidecar");
var spritesPieces_1 = require("../recyclers/spritesPieces");
var minigolfGameState_1 = require("../simulation/minigolfGameState");
var minigolfGameState_sidecar_1 = require("../simulation/minigolfGameState-sidecar");
var vectorUtils_sidecar_1 = require("../to-engine/vectorUtils-sidecar");
var minigolfPlacerSensor_sidecar_1 = require("../entities/minigolfPlacerSensor-sidecar");
var spritesUiCursors_1 = require("../recyclers/spritesUiCursors");
var namespace = 'minigolf-renderer';
// Helper functions between physics and rendering
var drawPhysicsItem = function (item, frame, tint) {
    var position = item.translation();
    var wp = minigolfCamera_sidecar_1.minigolfCamera.physicsToWorld(position.x, position.y);
    var sprite = spritesPieces_1.spritesPieces.getNext(wp.x, wp.y, frame);
    sprite.tint = tint;
    sprite.rotation = item.rotation();
    return sprite;
};
exports.drawPhysicsItem = drawPhysicsItem;
var applyPhysicsItem = function (item, sprite) {
    var position = item.translation();
    var wp = minigolfCamera_sidecar_1.minigolfCamera.physicsToWorld(position.x, position.y);
    sprite.x = wp.x;
    sprite.y = wp.y;
    sprite.rotation = item.rotation();
};
exports.applyPhysicsItem = applyPhysicsItem;
var getPhysicsPosition = function (item) {
    var position = item.translation();
    var wp = minigolfCamera_sidecar_1.minigolfCamera.physicsToWorld(position.x, position.y);
    return {
        x: wp.x,
        y: wp.y,
        rotation: item.rotation(),
    };
};
exports.getPhysicsPosition = getPhysicsPosition;
var render = function () {
    if (!minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.isLoaded()) {
        return;
    }
    var phys = minigolfPhysics_rapier_loader_sidecar_1.minigolfPhysics_rapier_loader.get();
    minigolfCreatures_sidecar_1.minigolfCreatures.renderAll();
    // minigolfBlocks.renderAll()
    // minigolfPucks.renderAll()
    minigolfPlacerSensor_sidecar_1.minigolfPlacerSensor.render();
    var isInMenu = false; // crokinoleUi_menu_main.isOpen()
    // drawPuck(puck1, diveColors.green)
    // drawPuck(puck2, diveColors.blueGray)
    // drawPhysicsItem(
    //   knocker,
    //   sprites.crokinoleCrokinolePiece[0],
    //   diveColors.orange,
    // )
    var state = minigolfGameState_sidecar_1.minigolfGameState.get();
    var cursorPhysicsPos = minigolfCamera_sidecar_1.minigolfCamera.getCursorPhysicsPosition();
    // let currentPlayer = crokinoleGameState.getCurrentPlayer()
    // let currentPp = crokinoleGameState.getCrokinolePlayerPosition(currentPlayer)
    var gamepadNum = 1;
    var gpi = minigolfGamepad_sidecar_1.minigolfGamepad.getInput(gamepadNum); //currentPlayer.gamepadNum)
    var isGamepadAccept = gpi.x === minigolfGamepad_1.InputState.JustDown ||
        gpi.a === minigolfGamepad_1.InputState.JustDown ||
        gpi.bumperRight === minigolfGamepad_1.InputState.JustDown ||
        gpi.triggerRight === minigolfGamepad_1.InputState.JustDown;
    var isGamepadDelete = gpi.y === minigolfGamepad_1.InputState.JustDown ||
        gpi.b === minigolfGamepad_1.InputState.JustDown ||
        gpi.bumperLeft === minigolfGamepad_1.InputState.JustDown ||
        gpi.triggerLeft === minigolfGamepad_1.InputState.JustDown;
    if (state.state === minigolfGameState_1.MinigolfGameStates.waitForPlayerFling) {
        // console.log(namespace, 'render wait for fling')
        if (!isInMenu) {
            var currentPuck = minigolfGameState_sidecar_1.minigolfGameState.getCurrentPlayer();
            if (currentPuck && !minigolfCreatures_sidecar_1.minigolfCreatures.isInactive(currentPuck)) {
                var puckPos = currentPuck.rigidBody.translation();
                var maxMagnitude = 2.5;
                var flingerPhysicsPos = {
                    x: cursorPhysicsPos.x,
                    y: cursorPhysicsPos.y,
                };
                // TODO: gamepad support
                // if (currentPlayer.controlScheme === CrokinoleControlScheme.gamepad) {
                //   let gp = crokinoleGamepadCursors.getByGamepadNumber(
                //     currentPlayer.gamepadNum,
                //   )
                //   if (gp) {
                //     crokinoleGamepadCursors.setColor(gp, currentPlayer.color)
                //     flingerPhysicsPos.x = gp.physicsX
                //     flingerPhysicsPos.y = gp.physicsY
                //   }
                // }
                var flingerToPuck1Delta = {
                    x: flingerPhysicsPos.x - puckPos.x,
                    y: flingerPhysicsPos.y - puckPos.y,
                };
                var magPrime = vectorUtils_sidecar_1.vectorUtils.magnitude(flingerToPuck1Delta);
                var puckSize = 0.2;
                // Make sure we are a minimum distance away from the puck
                if (magPrime >= puckSize / 8) {
                    // TODO: gamepad support
                    // if (currentPlayer.controlScheme === CrokinoleControlScheme.gamepad) {
                    //   flingerToPuck1Delta.x = gpi.axis2X * maxMagnitude
                    //   flingerToPuck1Delta.y = -gpi.axis2Y * maxMagnitude
                    //   magPrime = vectorUtils.magnitude(flingerToPuck1Delta)
                    // }
                    var flingOx = 0;
                    var flingOy = 0;
                    var flingerToHitPoint1Delta = {
                        x: flingerPhysicsPos.x - puckPos.x,
                        y: flingerPhysicsPos.y - puckPos.y,
                    };
                    if (minigolfDefs_sidecar_1.minigolfDefs.rule_advancedFlingPosition2) {
                        var anglePrime = vectorUtils_sidecar_1.vectorUtils.angle(flingerToPuck1Delta); // + mathUtils.turn(0.5)
                        var magBeforeTransform = vectorUtils_sidecar_1.vectorUtils.magnitude(flingerToHitPoint1Delta);
                        var elapsed = common_sidecar_1.common.getElapsedTime();
                        var angleOffsetAmount = mathUtils_sidecar_1.mathUtils.turn(1 / 24);
                        var angleOffset = mathUtils_sidecar_1.mathUtils.sineLike(elapsed, 2, -angleOffsetAmount, angleOffsetAmount);
                        anglePrime += angleOffset;
                        var _flingOx = -mathUtils_sidecar_1.mathUtils.cos(anglePrime);
                        var _flingOy = -mathUtils_sidecar_1.mathUtils.sin(anglePrime);
                        var scale = 1; // 0.1
                        flingerPhysicsPos.x -= _flingOx * scale;
                        flingerPhysicsPos.y -= _flingOy * scale;
                        flingerToHitPoint1Delta = {
                            x: flingerPhysicsPos.x - puckPos.x,
                            y: flingerPhysicsPos.y - puckPos.y,
                        };
                        flingerToHitPoint1Delta = vectorUtils_sidecar_1.vectorUtils.normalize(flingerToHitPoint1Delta);
                        flingerToHitPoint1Delta = vectorUtils_sidecar_1.vectorUtils.scale(flingerToHitPoint1Delta, magBeforeTransform);
                        // cursorToHitPoint1Delta.x += flingOx
                        // cursorToHitPoint1Delta.y += flingOy
                        // let offset = 10
                        // flingOx = mathUtils.cos(angle) * offset
                        // flingOy = mathUtils.sin(angle) * offset
                    }
                    if (minigolfDefs_sidecar_1.minigolfDefs.rule_advancedFlingPosition) {
                        var anglePrime = vectorUtils_sidecar_1.vectorUtils.angle(flingerToPuck1Delta) + mathUtils_sidecar_1.mathUtils.turn(0.5);
                        var elapsed = common_sidecar_1.common.getElapsedTime();
                        var angleOffsetAmount = mathUtils_sidecar_1.mathUtils.turn(1 / 6);
                        var angleOffset = mathUtils_sidecar_1.mathUtils.sineLike(elapsed, 2, -angleOffsetAmount, angleOffsetAmount);
                        anglePrime += angleOffset;
                        flingOx = -mathUtils_sidecar_1.mathUtils.cos(anglePrime) * puckSize;
                        flingOy = -mathUtils_sidecar_1.mathUtils.sin(anglePrime) * puckSize;
                        // cursorToHitPoint1Delta.x += flingOx
                        // cursorToHitPoint1Delta.y += flingOy
                        // let offset = 10
                        // flingOx = mathUtils.cos(angle) * offset
                        // flingOy = mathUtils.sin(angle) * offset
                    }
                    // if (crokinoleDefs.rule_advancedFlingPosition2) {
                    //   let anglePrime =
                    //     vectorUtils.angle(flingerToPuck1Delta) + mathUtils.turn(0.5)
                    //   let elapsed = common.getElapsedTime()
                    //   let angleOffsetAmount = mathUtils.turn(1 / 12)
                    //   let angleOffset = mathUtils.sineLike(
                    //     elapsed,
                    //     2,
                    //     -angleOffsetAmount,
                    //     angleOffsetAmount,
                    //   )
                    //   anglePrime += angleOffset
                    //   flingOx = -mathUtils.cos(anglePrime) * puckSize
                    //   flingOy = -mathUtils.sin(anglePrime) * puckSize
                    //   // cursorToHitPoint1Delta.x += flingOx
                    //   // cursorToHitPoint1Delta.y += flingOy
                    //   // let offset = 10
                    //   // flingOx = mathUtils.cos(angle) * offset
                    //   // flingOy = mathUtils.sin(angle) * offset
                    // }
                    var angle = vectorUtils_sidecar_1.vectorUtils.angle(flingerToHitPoint1Delta);
                    //console.log('mag is', mag)
                    var mag = vectorUtils_sidecar_1.vectorUtils.magnitude(flingerToHitPoint1Delta);
                    if (mag > maxMagnitude) {
                        // Scale to max mag
                        flingerToHitPoint1Delta = vectorUtils_sidecar_1.vectorUtils.normalize(flingerToHitPoint1Delta);
                        flingerToHitPoint1Delta = vectorUtils_sidecar_1.vectorUtils.scale(flingerToHitPoint1Delta, maxMagnitude);
                        mag = maxMagnitude;
                        //console.log('mag is', mag)
                    }
                    // Draw our hit indicators
                    var numIndicators = 7;
                    for (var i = 1; i <= numIndicators; i++) {
                        var t = i / numIndicators;
                        var v = vectorUtils_sidecar_1.vectorUtils.normalize(flingerToHitPoint1Delta);
                        // mag -= 0.5
                        // if (mag < 0) {
                        //   mag = 0.05
                        // }
                        v = vectorUtils_sidecar_1.vectorUtils.scale(v, t * mag);
                        v = vectorUtils_sidecar_1.vectorUtils.add(v, puckPos);
                        v = vectorUtils_sidecar_1.vectorUtils.add(v, { x: flingOx, y: flingOy });
                        var wp = minigolfCamera_sidecar_1.minigolfCamera.physicsToWorld(v.x, v.y);
                        var sprite = spritesUiCursors_1.spritesUiCursors.getNext(wp.x, wp.y, sprites_sidecar_1.sprites.crokinoleCrokinoleArrow[0]);
                        sprite.rotation = -angle + mathUtils_sidecar_1.mathUtils.turn(-0.25);
                    }
                    if (clickEater_sidecar_1.clickEater.isLeftFirstDownAndUneaten() || isGamepadAccept) {
                        clickEater_sidecar_1.clickEater.tempEat();
                        // TODO: only apply on step?
                        // TODO: move fling elsewhere
                        var impulseMultiplier = 0.75;
                        // TODO: timing for left and right
                        // TODO: restore input
                        console.log(namespace, 'fling', currentPuck.id, flingerToHitPoint1Delta.x, flingerToHitPoint1Delta.y, angle, impulseMultiplier);
                        minigolf_input_sidecar_1.minigolf_input.requestHost({
                            hint: minigolf_input_sidecar_1.minigolf_input.EMinigolfInputHint.FlingDisc,
                            frame: 0,
                            targetId: currentPuck.id,
                            wx: puckPos.x + flingOx,
                            wy: puckPos.y + flingOy,
                            fx: flingerToHitPoint1Delta.x * -impulseMultiplier,
                            fy: flingerToHitPoint1Delta.y * -impulseMultiplier,
                            angle: 0,
                            playerNum: 0, //currentPlayer.playerNum,
                        });
                        // crokinole_input.requestHost({
                        //   hint: crokinole_input.ECrokinoleInputHint.FlingDisc,
                        //   frame: 0, // Calc Frame
                        //   targetId: currentPuck.id,
                        //   wx: puckPos.x + flingOx, // phys.placerSensor.translation().x,
                        //   wy: puckPos.y + flingOy, // phys.placerSensor.translation().y,
                        //   fx: flingerToHitPoint1Delta.x * -impulseMultiplier,
                        //   fy: flingerToHitPoint1Delta.y * -impulseMultiplier,
                        //   angle: phys.placerSensor.rotation(),
                        //   playerNum: currentPlayer.playerNum,
                        // })
                    }
                }
            }
        }
    }
    // Render pegs
    // for (let i = 0; i < phys.poles.length; i++) {
    //   let pole = phys.poles[i]
    //   drawPhysicsItem(pole, sprites.crokinoleCrokinolePeg[0], diveColors.gray)
    // }
    // Render green arc
};
exports.render = render;
